import {v4 as uuidv4} from 'uuid';

const actionKeys = {
  enqueue: 'Enqueue',
  remove: 'Remove',
  clear: 'Clear',
};

const enqueue = (event) => async (dispatch) => {
  const nextEvent = {
    id: event?.id || uuidv4(),
    type: event?.type || 'track',
    ...event,
  };

  dispatch({
    type: actionKeys.enqueue,
    payload: nextEvent,
  });
};

const remove = (id) => async (dispatch) => {
  dispatch({
    type: actionKeys.remove,
    payload: {id},
  });
};

const clear = () => async (dispatch) => {
  dispatch({
    type: actionKeys.clear,
  });
};

const reducer = (state = {queue: []}, action) => {
  switch (action.type) {
    case actionKeys.enqueue:
      return {
        ...state,
        queue: [...state.queue, action.payload],
      };
    case actionKeys.remove:
      return {
        ...state,
        queue: state.queue.filter((event) => event.id !== action.payload.id),
      };
    case actionKeys.clear:
      return {
        ...state,
        queue: [],
      };
    default:
      return state;
  }
};

export default {
  actions: {
    enqueue,
    remove,
    clear,
  },
  reducer: reducer,
};
